import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import getDynamicPaymentSchedule from './getDynamicPaymentSchedule'

const getDynamicPaymentScheduleDepositAmount = createSelector(
  getDynamicPaymentSchedule,
  (dynamicPaymentSchedule): number => {
    if (!dynamicPaymentSchedule?.eligible || !dynamicPaymentSchedule?.initialPaymentSchedule) {
      return 0
    }
    return floatify(dynamicPaymentSchedule.initialPaymentSchedule.expectedAmount)
  },
)

export default getDynamicPaymentScheduleDepositAmount
